import React from 'react';
import { createUseStyles } from 'react-jss';

import { flex } from '@resources/mixins';

import { UserInfoForm } from '../UserInfoForm';
import { UserAvatarView } from '../UserAvatarView';
import { PairedDevicesView } from '../PairedDevicesView';
import { mediaDown, ThemeProps } from '@styles/theme';
import { useTheme } from '@mui/material/styles';

const useStyles = createUseStyles(() => ({
    wrapper: {
        ...flex('row', 'space-between'),

        [mediaDown('desktop')]: {
            ...flex('column'),
        },
    },
}));

export const ProfilePage: React.FC = () => {
    const theme = useTheme<ThemeProps>();
    const styles = useStyles({ theme });

    return (
        <>
            <div className={styles.wrapper}>
                <UserInfoForm />
                <UserAvatarView />
            </div>

            <PairedDevicesView />
        </>
    )
}
